exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._30mRUYv4WVm5MVb--SfEn5{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}._3yURCq4teDIVxZo7Qg3gYm,._30mRUYv4WVm5MVb--SfEn5{line-height:28px;height:28px}._1mKS_Yyy7uP28FtvK6DpNa{-webkit-box-flex:0;-ms-flex:0 0 35%;flex:0 0 35%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] ._1mKS_Yyy7uP28FtvK6DpNa{margin-right:30px}html[dir=rtl] ._1mKS_Yyy7uP28FtvK6DpNa{margin-left:30px}.yBrP7Uhmi-MB_VYRTlIJ2{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}html[dir=ltr] .yBrP7Uhmi-MB_VYRTlIJ2{margin-right:30px}html[dir=rtl] .yBrP7Uhmi-MB_VYRTlIJ2{margin-left:30px}._1gd7hT-Dtouv8YWULCGReM{color:\"[theme:themePrimary, default:#0078D7]\"}._18wsNxNXkEquUwxCUtV0mF{color:\"[theme:themeDarkAlt, default:#005A9E]\"}", ""]);

// exports
exports.locals = {
	"details": "_30mRUYv4WVm5MVb--SfEn5",
	"button": "_3yURCq4teDIVxZo7Qg3gYm",
	"displayName": "_1mKS_Yyy7uP28FtvK6DpNa",
	"smtp": "yBrP7Uhmi-MB_VYRTlIJ2",
	"buttonLabel": "_1gd7hT-Dtouv8YWULCGReM",
	"buttonHovered": "_18wsNxNXkEquUwxCUtV0mF"
};